const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    headOffice: () =>
        __('Hovedkontor'),
    founded: () =>
        __('Grundlagt'),
    employees: () =>
        __('Ansatte'),
    employeesSource: (year, source) =>
        __x('Kilde: {source} {year}', { year, source }),
    homepage: () =>
        __('Hjemmeside'),
    careerpage: () =>
        __('Karrieresite'),
    getTitle: (name) =>
        __x('Besøg os på {name}', { name }),
    clickHeader: (selected) =>
        __x('Klikstatistik {selected}', { selected }),
    latestYear: () =>
        __('Seneste år'),
    latestMonth: () =>
        __('Seneste måned'),
    series1Legend: () =>
        __('Visninger i oversigten'),
    series2Legend: () =>
        __('Visninger i profil'),
    moreActions: () =>
        __('Flere handlinger'),
    employeeHeader: (companyname) =>
        __x('Ansat i {companyname}?', { companyname }),
    employeeEvaluate: () =>
        __('Se evalueringer eller evaluer virksomheden her.'),
    employeeShort: () =>
        __('Se, hvordan du kan styrke dit employer brand med en'),
    employeeShortLink: () =>
        __('virksomhedsprofil på Jobindex.'),
    admin: () =>
        __('Administrator'),
    graphFormatterText: (date, views) =>
        __x('{date}: {views} visninger', { date, views }),
    actionText(type) {
        switch (type) {
            case 'writeNews':
                return  __('Skriv en nyhed til dine følgere');
            case 'followerStatistics':
                return  __('Se statistik over dine følgere');
            case 'ratings':
                return  __('Se din evalueringsdata');
            case 'editCompany':
                return  __('Ret gratis Virksomhedsprofil');
        }
    },
    internalAdmTexts(type, isFree) {
        switch (type) {
            case 'editPaidProfile':
                return  (isFree ? __('Opret betalt profil') : __('Rediger betalt profil'));
            case 'editFreeProfile':
                return  __('Ret gratis profil (social network)');
            case 'editMasterData':
                return  __('Ret virksomhedens stamdata');
            case 'ratingsData':
                return  __('Statistik over evalueringsdata');
            case 'editGaisData':
                return  __('Redigering af GAIS data');
        }
    },
};
